<!-- Page Wrapper -->
<div class="page-wrapper" style="min-height: 347px;">
    <div class="content container-fluid">
        <div class="bg-white page-border">
            <!--page body contant -->
            <!--header-->
            <div class="row row-replace add-m-b">
                <div class="col-md-6 col-9 col-p h5"><i class="fa fa-tachometer"></i> Payroll Management Dashboard</div>
                <div class="col-md-6 col-3 top-corner-items col-p">
                    <!-- <button class="btn btn-primary btn-sm"><i class="fa fa-plus"></i> Manpower Requisition</button> -->
                </div>
            </div>
            <!--end header-->

       <!--Payroll Dashboard Cycle  -->
            <div class="row row-replace m-t-10 menu-column border border-rad">
                <div class="col-12 bg-primary text-white menu-head border-rad h5 add-p-tb m-b-0">
                   <i class="fa fa-link"></i> Payroll Dashboard Cycle - 25-06-2021 to 31-07-2021 (Region Wise)
                </div>
                <div class="col-12 col-pn">
                   <div class="table-responsive">
                      <table class="table table-align">
                         <thead>
                           <th>Ranking Regions</th>
                           <th>No of Sites</th>
                           <th>No of Employees</th>
                           <th>This Month new Joinees</th>
                           <th>Pending DOJ Conformation by site</th>
                           <th>Yesterday Confirmed DOJ</th>
                           <th>Pending %</th>
                           <th>Employees without Bank Account</th>
                           <th>Yesterday Approved Bank Accounts</th>
                           <th>Pending %</th>
                           <th>Total Exit for the month</th>
                           <th>Pending Exit Approval by Site / Reg SPOC</th>
                           <th>Yesterday Approved Exit by Reg SPOC</th>
                           <th>Pending %</th>
                           <th>Monthly Transfer Count</th>
                           <th>Pending Transfer Approval</th>
                           <th>Yesterday Transfer Approved by SPOC</th>
                           <th>Pending %</th>
                           <th>Overall Pending %</th>
                         </thead>
                         <tr>
                             <td colspan="19" class="text-danger" style="text-align: left !important;">
                                Top 3	Regions	
                             </td>
                         </tr>
                         <tbody>
                            <tr>
                               <td>0</td>
                               <td>0</td>
                               <td>0</td>
                               <td>0</td>
                               <td>0</td>
                               <td>0</td>
                               <td>0</td>
                               <td>0</td>
                               <td>0</td>
                               <td>0</td>
                               <td>0</td>
                               <td>0</td>
                               <td>0</td>
                               <td>0</td>
                               <td>0</td>
                               <td>0</td>
                               <td>0</td>
                               <td>0</td>
                               <td>0</td>
                            </tr>
                         </tbody>
                         <tr>
                            <td colspan="19" class="text-danger" style="text-align: left !important;">
                               Buttom	Regions	
                            </td>
                        </tr>
                        <tbody>
                           <tr>
                            <td>0</td>
                            <td>0</td>
                            <td>0</td>
                            <td>0</td>
                            <td>0</td>
                            <td>0</td>
                            <td>0</td>
                            <td>0</td>
                            <td>0</td>
                            <td>0</td>
                            <td>0</td>
                            <td>0</td>
                            <td>0</td>
                            <td>0</td>
                            <td>0</td>
                            <td>0</td>
                            <td>0</td>
                            <td>0</td>
                            <td>0</td>
                           </tr>
                        </tbody>
                      </table>
                   </div>
                </div>
             </div>

<!--Pending Bank Account Dashboard Cycle -->
            <div class="row row-replace m-t-10 menu-column border border-rad">
                <div class="col-12 bg-primary text-white menu-head border-rad h5 add-p-tb m-b-0">
                <i class="fa fa-link"></i> Pending Bank Account Dashboard Cycle - 25-06-2021 to 31-07-2021 (Region Wise)
                </div>
                <div class="col-12 col-pn">
                <div class="table-responsive">
                    <table class="table table-align">
                        <thead>
                           <th>Ranking Regions	</th>
                           <th>	No of Sites</th>
                           <th>No of Employees</th>
                           <th>This Month Active new Joinees</th>
                           <th>Employees without Bank Account</th>
                           <th>Yesterday Approved Bank Accounts	</th>
                           <th>Pending %</th>
                        </thead>
                        <tr>
                            <td colspan="7" class="text-danger" style="text-align: left !important;">
                               Top 3	Regions	
                            </td>
                        </tr>
                        <tbody>
                           <tr>
                              <td>0</td>
                              <td>0</td>
                              <td>0</td>
                              <td>0</td>
                              <td>0</td>
                              <td>0</td>
                              <td>0</td>
                           </tr>
                        </tbody>
                        <tr>
                           <td colspan="7" class="text-danger" style="text-align: left !important;">
                              Buttom	Regions	
                           </td>
                       </tr>
                       <tbody>
                          <tr>
                             <td>0</td>
                             <td>0</td>
                             <td>0</td>
                             <td>0</td>
                             <td>0</td>
                             <td>0</td>
                             <td>0</td>
                          </tr>
                       </tbody>
                     </table>
                </div>
                </div>
            </div>
            
<!-- Attendance Dashboard Cycle  -->
            <div class="row row-replace m-t-10 menu-column border border-rad">
                <div class="col-12 bg-primary text-white menu-head border-rad h5 add-p-tb m-b-0">
                <i class="fa fa-link"></i> Attendance Dashboard Cycle - 2021-07-01 to 2021-07-31 (Region Wise)
                </div>
                <div class="col-12 col-pn">
                <div class="table-responsive">
                    <table class="table table-align">
                        <thead>
                           <th>Ranking Regions</th>
                           <th>Pending Upload Sites</th>
                           <th>Pending %</th>
                           <th>Pending Employee Attendance</th>
                           <th>Pending %</th>
                           <th>Overall Pending %</th>
                        </thead>
                        <tr>
                            <td colspan="6" class="text-danger" style="text-align: left !important;">
                               Top 3	Regions	
                            </td>
                        </tr>
                        <tbody>
                           <tr>
                              <td>0</td>
                              <td>0</td>
                              <td>0</td>
                              <td>0</td>
                              <td>0</td>
                              <td>0</td>
                           </tr>
                        </tbody>
                        <tr>
                           <td colspan="6" class="text-danger" style="text-align: left !important;">
                              Buttom	Regions	
                           </td>
                       </tr>
                       <tbody>
                          <tr>
                             <td>0</td>
                             <td>0</td>
                             <td>0</td>
                             <td>0</td>
                             <td>0</td>
                             <td>0</td>
                          </tr>
                       </tbody>
                     </table>
                </div>
                </div>
            </div>

            
             
             

      <!--end page body contant -->
        </div>
    </div>
</div>
<!-- /Page Wrapper -->           

